<div class="menu-crud-shape menu-crud-wrapper" [ngClass]="{'drag-menu-active':(svcMenuBase.svcMenuDrag.menuOpen | async), 'crud-menu-active':(svcMenuBase.svcMenuCrud.menuOpen | async), 'crud-menu-capture':svcMenuBase.svcMenuCrud.crudMenuFoodMode === 'capturing', 'crud-menu-hide-tables':(svcMenuBase.svcMenuCrud.menuType | async) === 'mood'}">
	<div class="menu-crud-content">
		<div class="menu-crud-panels" id="PanelWrapperCrud">
			@for (
					btn of svcMenuBase.svcMenuCrud.menuPanels; track btn.uuid) {
				<div class="menu-crud-panel" [ngClass]="'menu-crud-panel-'+btn.type" [id]="'ScrollPanel-'+btn.type">
					@if (btn.comp) {
						<ng-container class="block w-full h-full" [ngComponentOutlet]="btn.comp"></ng-container>
					}
				</div>
			}
		</div>

		<div class="crud-tables crud-tables-l">
			<div class="bg-black"></div>
			<div class="bg-black"></div>
			<div class="bg-black"></div>
			<div class="bg-black"></div>
			<div class="bg-black"></div>
			<div class="bg-black"></div>
		</div>

		<div class="crud-tables crud-tables-c">
			<div class="status-text" (click)="downloadSevenDayData()">
				{{downloadButton.text}}
			</div>
			<div class="status-text">v{{v.version}}</div>
			<div class="status-text"></div>
		</div>

		<div class="crud-tables crud-tables-r">
			<app-ui-status-item [statusItem]="viewHome" itemPath="/home"></app-ui-status-item>
			<app-ui-status-item [statusItem]="viewDays" itemPath="/days"></app-ui-status-item>
			<app-ui-status-item [statusItem]="sumItemsR"></app-ui-status-item>
			@for (
					btn of tabItems; track btn.uuid) {
				<div class="crud-table-btn" (click)="btn.func()">
					<i class="fa-sharp fat" [ngClass]="'fa-'+btn.icon"></i>
				</div>
			}
			<app-ui-status-item [statusItem]="sumItemsR"></app-ui-status-item>


		</div>

		<div class="menu-btns-wrapper" id="MenuBtnsWrapper">
			<div class="menu-btns" [ngClass]="{'menu-btns-active':!(svcMenuBase.svcMenuDrag.menuOpen | async)}">
				<div class="menu-btn-space"></div>
				@for (
						btn of svcMenuBase.svcMenuCrud.menuPanels; track btn.uuid) {
					<div class="tool-btn" [ngClass]="{'tool-btn-active':(svcMenuBase.svcMenuCrud.menuType | async) === btn.type}" (click)="svcMenuBase.menuCrudToggle($index, btn.type)">
						<i class="fa-sharp fat" [ngClass]="(svcMenuBase.svcMenuCrud.menuType | async) === btn.type ? 'fa-xmark-large' : 'fa-'+btn.icon"></i>
					</div>
				}
				<div class="menu-btn-space"></div>
			</div>
			<div class="menu-btns menu-btns-drag" [ngClass]="{'menu-btns-active':(svcMenuBase.svcMenuDrag.menuOpen | async)}">
				@for (
						btn of svcMenuBase.svcMenuDrag.menuPanels; track btn.uuid) {
					<div class="tool-btn" [ngClass]="{'tool-btn-active':(svcMenuBase.svcMenuDrag.menuType | async) === btn.type}" (click)="svcMenuBase.menuDragToggle($index, btn.type)">
						<i class="fa-sharp fat" [ngClass]="(svcMenuBase.svcMenuDrag.menuType | async) === btn.type ? 'fa-xmark-large' : 'fa-'+btn.icon"></i>
					</div>
				}
			</div>
		</div>
	</div>
	<app-ui-video-bg></app-ui-video-bg>
</div>
<div class="menu-crud-holo" [ngClass]="{'drag-menu-active':(svcMenuBase.svcMenuDrag.menuOpen | async), 'crud-menu-active':(svcMenuBase.svcMenuCrud.menuOpen | async), 'crud-menu-capture':svcMenuBase.svcMenuCrud.crudMenuFoodMode === 'capturing', 'crud-menu-hide-tables':(svcMenuBase.svcMenuCrud.menuType | async) === 'mood'}">
	<div class="menu-crud-holo-inner">
		@let
		type = (svcMenuBase.svcMenuCrud.menuType | async);
		@if (type) {
			@let
			comp = svcMenuBase.svcMenuCrud.panelMenuCompsBot[type];
			@if (comp) {
				<ng-container class="block w-full h-full" [ngComponentOutlet]="comp"></ng-container>
			}
		}
	</div>
	<div class="menu-crud-holo-bg"></div>
	<app-ui-video-bg></app-ui-video-bg>
</div>
<!--<div class="menu-crud-holo-line" [ngClass]="{'drag-menu-active':(svcMenuBase.svcMenuDrag.menuOpen | async), 'crud-menu-active':(svcMenuBase.svcMenuCrud.menuOpen | async), 'crud-menu-capture':svcMenuBase.svcMenuCrud.crudMenuFoodMode === 'capturing', 'crud-menu-hide-tables':(svcMenuBase.svcMenuCrud.menuType | async) === 'mood'}"></div>-->
